import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constant } from 'src/Constant';
import { GlobalServiceService } from 'src/app/Services/GlobalService/global-service.service';

@Component({
  selector: 'app-razor-pay-failure',
  templateUrl: './razor-pay-failure.component.html',
  styleUrls: ['./razor-pay-failure.component.css']
})
export class RazorPayFailureComponent implements OnInit {
  errorMsg:any;
  isSuccess:boolean = false;
  source:any;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private service: GlobalServiceService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {

    if(localStorage.getItem('razorpayError')){
      this.errorMsg = JSON.parse(localStorage.getItem('razorpayError')|| '{}');
      console.log(this.errorMsg);
      this.isSuccess = true;
      this.callAPI();
    }

    this.route.queryParams.subscribe(params => {
      const source = params['source'];
      console.log(source); // do something with the error
    });


  }
  
  Retry(){
    this.localStorageService.clearAll();
    this.router.navigate(['/MandateHome']);
  }

  ngOnDestroy() {
    localStorage.clear();
  }

  callAPI() {
    if (this.source = 'RP_UPI') {
      this.saveFaliedResUPI()
    }

    if (this.source = 'RP_NB') {
      this.saveFailedResNB()
    }
  }


  saveFailedResNB(){
    let url = Constant.saveMandateSign;
    if(this.errorMsg){
      let reqObj = {
        "razorpay_PaymentId": this.errorMsg.error.metadata.payment_id,
        "razorpay_orderId": this.errorMsg.error.metadata.order_id,
        "razorpay_signiture":""
    }
        this.service.PostService(url, reqObj).subscribe(response => {
            // add loader here 
        })
    }
  }

  
  saveFaliedResUPI(){
    let url = Constant.saveMandateSignUPI;
    if(this.errorMsg){
      let reqObj = {
        "razorpay_PaymentId": this.errorMsg.error.metadata.payment_id,
        "razorpay_orderId": this.errorMsg.error.metadata.order_id,
        "razorpay_signiture":""
    }
        this.service.PostService(url, reqObj).subscribe(response => {
            // add loader here 
        })
    }
  }


}
